import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { safeSmoothScrollTo } from '../../../utils/utils';
import { useSanitizedLocation } from '../../../features/navigation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentItem = ({
  url,
  heading,
  subheading
}) => {
  const location = useSanitizedLocation();
  return /*#__PURE__*/_jsxs(UIRouterLink, {
    className: "lesson-content-item",
    "data-test-id": "lesson-content-item",
    onClick: () => {
      safeSmoothScrollTo(window, 0, 0);
    },
    to: Object.assign({}, location, {
      pathname: url
    }),
    use: "unstyled",
    children: [/*#__PURE__*/_jsx("div", {
      className: "lesson-content-item__heading",
      children: heading
    }), /*#__PURE__*/_jsx("div", {
      className: "lesson-content-item__subheading",
      children: subheading
    })]
  });
};
export default ContentItem;